/**
 * @generated SignedSource<<dc083a19214040501dc7bea74d827ac8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutRelayAction_emailUser$data = {
  readonly " $fragmentSpreads": FragmentRefs<"checkoutShippingReducer_emailUser">;
  readonly " $fragmentType": "checkoutRelayAction_emailUser";
};
export type checkoutRelayAction_emailUser$key = {
  readonly " $data"?: checkoutRelayAction_emailUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutRelayAction_emailUser">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutRelayAction_emailUser"
};

(node as any).hash = "0844bbab57c9f92a07230b4f364d4af4";

export default node;
